import React from 'react';
import roles from 'helpers/roles';
import { withTranslation } from 'react-i18next';
import withStyles from '@material-ui/core/styles/withStyles';
import { combineStyles } from 'helpers/helpers';
import buttonsStyle from 'assets/jss/material-dashboard-pro-react/views/buttonsStyle.jsx';
import extendedFormsStyle from 'assets/jss/material-dashboard-pro-react/views/extendedFormsStyle';
import { compose } from 'redux';
import getReportFileNameWithMultiplier from 'helpers/getReportFileNameWithMultiplier';

import CombinedReport from './CombinedReport/CombinedReport';
import MIME_TYPES from './constants/mimeTypes';

class DishesChecklist extends React.Component {
  state = {
    includeSubscriptions: false,
  };

  render() {
    const { t } = this.props;

    return (
      <CombinedReport
        name="CHECK_LIST_DISHES"
        title={t('reports.reportDishesCheck')}
        url="reports/checklist-dishes"
        previewPdfAvailable={true}
        previewXlsxAvailable={true}
        mimeTypes={[MIME_TYPES.pdf, MIME_TYPES.xlsx]}
        role={roles.ROLE_SHOW_REPORT_CHECKLIST_RECIPES}
        fileName={params =>
          getReportFileNameWithMultiplier(
            params,
            this.props.t('common.mainMenu.reportsDishesChecklist')
          )
        }
        useDateRange={true}
        showMultiplier={true}
        validateBrands={false}
        validateDatePicker={true}
        useSubBrands={true}
        useZoneCategories={true}
        useRecipeTags={true}
        singleSelectRecipeTags={true}
        isTagSelectV2Enabled={true}
        labelSelectTags={t('reports.selectTags')}
        isSalesMarketLangViewEnabled={true}
        archiveReportNames={['CHECK_LIST_DISHES']}
        reportConfiguration={{
          report: 'ChecklistDishes',
          fields: [
            {
              size: 12,
              field: 'roundDecimalPoints',
              inputType: 'number',
            },
            {
              size: 12,
              field: 'forceKg',
              inputType: 'select',
              inputProps: {
                multiple: false,
                options: [
                  {
                    value: true,
                    label: this.props.t('common.yes'),
                  },
                  {
                    value: false,
                    label: this.props.t('common.no'),
                  },
                ],
              },
            },
            {
              size: 12,
              field: 'showSum',
              name: 'showSum',
              inputType: 'checkbox',
            },
            {
              size: 12,
              field: 'showTotalWeightIngredient',
              name: 'showTotalWeightIngredient',
              inputType: 'checkbox',
            },
          ],
        }}
      />
    );
  }
}

const combinedStyles = combineStyles(extendedFormsStyle, buttonsStyle);

const enhance = compose(withStyles(combinedStyles), withTranslation());

export default enhance(DishesChecklist);
